import { z } from 'zod';

export const AddSigningDocumentInput = z.object({
  documentFile: z.object(
    {
      uri: z.string(),
      objectKey: z.string().startsWith('private/vehicle-signing-documents/'),
      fileName: z.string(),
    },
    { required_error: 'Please upload a document for signing.' },
  ),
  maxUniqueSigners: z.number().min(1).max(4),
  requireWitnessing: z.boolean(),
});
